/**
 * THE LOCALIZED FIELD: one value in several languages, edited in place
 * (`shared/localizedField`). Its rows, its acts, and the problems a draft
 * reports back, each attributed to the language it is about.
 */
export const localizedField = {
  'localizedField.badge': 'Languages of this value',
  'localizedField.original': 'Original',
  'localizedField.makeOriginal': 'Make original',
  'localizedField.makeOriginalFor': 'Make {language} the original',
  'localizedField.remove': 'Remove {language}',
  'localizedField.addLanguage': 'Add a language',
  'localizedField.addLanguagePlaceholder': 'Choose a language',
  'localizedField.suggest': 'Suggest',
  'localizedField.suggestFor': 'Suggest {language}',
  'localizedField.suggestAll': 'Suggest all missing',
  'localizedField.suggesting': 'Suggesting…',
  'localizedField.suggestFailed': 'The suggestion could not be prepared. Try again.',
  'localizedField.sourceRequired': 'The original text is required.',
  'localizedField.blank': 'Type the translation or remove the language.',
  'localizedField.tooLong': 'The text is too long.',
  'localizedField.invalidText': 'The text contains characters that cannot be stored.',
  'localizedField.tooManyLanguages': 'No more languages can be added to this value.',
  'localizedField.shownIn': 'Shown in {language}',
} as const
